import { withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { ScoutConnectionImapFormProvider } from './contexts/scoutConnectionImapFormContext'
import { ScoutConnectionImapModalComponent } from './elements/ScoutConnectionImapModalComponent'

const ScoutConnectionImap = (): ReactElement => {
  return (
    <ScoutConnectionImapFormProvider>
      <ScoutConnectionImapModalComponent />
    </ScoutConnectionImapFormProvider>
  )
}

export const ScoutConnectionImapModal = withModalConditionalRender(ScoutConnectionImap)
